module.exports = __webpack_public_path__ + "static/media/PIL.6e205ffe.svg";